module.exports = __webpack_public_path__ + "img/line-of-credit-circle.5977cbc6.svg";